import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { VALIDATED } from '../../../../../services/checkout/constants';
import { KYC_STATE_VALIDATED } from '../../../../../services/kyc/constants';

import { fetchPaypalDetails } from '../../../../../services/paypal/actions';
import { fetchCheckoutDetails } from '../../../../../services/checkout/actions';

import { convertHtmlToReactDomWithParams } from '../../../../../utils/htmlUtils';

import { LoadingComponent } from '../../../../loading/LoadingComponent';

import './ConfirmationEbonPageKycBlocStyle.scss';

const ConfirmationEbonPageKycBloc = ({
    orderId,
    checkoutSessionId,
    checkoutPaymentId,
    paypalCost,
    paymentRef,
    fetchingOrder,
    ebonOrderState,
    kyc,
    setKyc,
    kycValidated,
    setKycValidated,
    detailsInterval,
    setDetailsInterval,
    i18n,
    kycState,
    fetchCheckoutDetails,
    fetchPaypalDetails
}) => {
    const fetchDetails = () => {
        if (checkoutSessionId || checkoutPaymentId) {
            fetchCheckoutDetails(orderId, checkoutPaymentId);
        } else if (!!paypalCost) {
            fetchPaypalDetails(paymentRef);
        }
    };

    /* Start KYC verification */
    useEffect(() => {
        if (kycState === KYC_STATE_VALIDATED) {
            setKycValidated(true);
            setKyc(false);
            fetchDetails();
        }
    }, [kycState]);

    useEffect(() => {
        if (kycValidated) {
            const interval = setInterval(() => {
                fetchDetails();
            }, 5000);
            setDetailsInterval(interval);

            return () => clearInterval(interval);
        }
    }, [kycValidated]);
    /* End KYC verification */

    return (
        !fetchingOrder &&
        ebonOrderState !== VALIDATED &&
        !kyc &&
        kycValidated && (
            <div id="kyc-container">
                <h3>{convertHtmlToReactDomWithParams(i18n.WAITING_TRANSACTION.TEXT_1)}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.WAITING_TRANSACTION.TEXT_2)}</p>
                <div className="loader-wrapper">
                    <LoadingComponent />
                </div>
            </div>
        )
    );
};

ConfirmationEbonPageKycBloc.propTypes = {
    orderId: PropTypes.string,
    checkoutSessionId: PropTypes.string,
    checkoutPaymentId: PropTypes.string,
    paypalCost: PropTypes.string,
    paymentRef: PropTypes.string,
    fetchingOrder: PropTypes.bool,
    ebonOrderState: PropTypes.string,
    kyc: PropTypes.bool,
    setKyc: PropTypes.func,
    kycValidated: PropTypes.bool,
    setKycValidated: PropTypes.func,
    detailsInterval: PropTypes.number,
    setDetailsInterval: PropTypes.func
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON.CONFIRMATION,
        kycState: state.kyc.state
    };
};

const mapDispatchToProps = {
    fetchCheckoutDetails,
    fetchPaypalDetails
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationEbonPageKycBloc);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/kyc/ConfirmationEbonPageKycBloc.js